import { render } from "./sms_set.vue?vue&type=template&id=6873a602&scoped=true"
import script from "./sms_set.vue?vue&type=script&lang=js"
export * from "./sms_set.vue?vue&type=script&lang=js"

import "./sms_set.vue?vue&type=style&index=0&id=6873a602&scoped=true&lang=css"

import exportComponent from "G:\\workBench\\my_server_project\\eventvue\\myEvents\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6873a602"]])

export default __exports__